import { EVENT_LISTENER_BINDINGS } from './renderer';

/**
 * Using the {@link HostEvent} decorator you can easily define a class method to
 * an {@see Event} on the Component or Directive's DOM element.
 *
 * In the example below we're creating a Directive which should log the value of
 * an input element on every `change` event:
 *
 * ```typescript
 * @DomDirective({
 *  selector: 'aa-log-value'
 * })
 * class LogValueDirective {
 *  @HostElement
 *  private readonly inputElm: HTMLInputElement;
 *
 *  @HostEvent('change')
 *  onChange(e: Event) {
 *    console.log("My value is: " + this.inputElm.value);
 *  }
 * }
 * ```
 *
 * @param event
 */
export const HostEvent = (event: string): MethodDecorator => {
  return function (target: any, propertyKey: string | symbol, descriptor: PropertyDescriptor): void {
    target[EVENT_LISTENER_BINDINGS] = target[EVENT_LISTENER_BINDINGS] ? target[EVENT_LISTENER_BINDINGS] : [];
    target[EVENT_LISTENER_BINDINGS].push({
      event: event,
      fn: descriptor.value,
    });
  };
};
